import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ProgressReportSkeleton = () => {
  const cards = [
    "Overall Efforts",
    "Development Progress",
    "QA Progress"
  ];

  return (
    <div className="row px-0 mx-0">
      <div className="card-box">
          <div className="text-sm font-semibold mb-1">
            <Skeleton width={200} height={16} />
          </div>
          <div className="text-xs text-gray-500 mb-2">
            <Skeleton width={160} />
          </div>

          <div className="flex justify-center items-center" style={{ height: 180 }}>
            <Skeleton circle width={150} height={150} />
          </div>

          <div className="mt-2">
            <Skeleton width={120} height={14} count={2} />
          </div>
      </div>
      <div className="card-box">
          <div className="text-sm font-semibold mb-1">
            <Skeleton width={200} height={16} />
          </div>
          <div className="text-xs text-gray-500 mb-2">
            <Skeleton width={160} />
          </div>

          <div className="flex justify-center items-center" style={{ height: 180 }}>
            <Skeleton circle width={150} height={150} />
          </div>

          <div className="mt-2">
            <Skeleton width={120} height={14} count={2} />
          </div>
      </div>
      <div className="card-box">
          <div className="text-sm font-semibold mb-1">
            <Skeleton width={200} height={16} />
          </div>
          <div className="text-xs text-gray-500 mb-2">
            <Skeleton width={160} />
          </div>

          <div className="flex justify-center items-center" style={{ height: 180 }}>
            <Skeleton circle width={150} height={150} />
          </div>

          <div className="mt-2">
            <Skeleton width={120} height={14} count={2} />
          </div>
      </div>
    </div>
  );
};

export default ProgressReportSkeleton;
